var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('graphic',{attrs:{"src":_vm.sources,"muted":true,"loop":_vm.loop,"autoplay":_vm.autoplay,"delay":_vm.delay,"loop-count":_vm.loopCount}})}
var staticRenderFns = []

export { render, staticRenderFns }